<!--时间间隔选择-->
<template>
	<div class="checkbox">
		<div @click.stop="checkItem(1)"><img :src="getImg(1)" /><span>是</span></div>
		<div @click.stop="checkItem(0)"><img :src="getImg(0)" /><span>否</span></div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		model: {
			prop: 'booleanValue',
			event: 'checkItem'
		},
		components: {},
		props: {
			booleanValue: [String,Number],
			defaultValue:Number,
			disable: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {}
		},
		created() {
			if(this.defaultValue != undefined){
				this.checkItem(this.defaultValue)
			}
		},
		mounted() {},
		destroyed() {},
		computed: {
			getImg() {
				return i => {
					if(this.booleanValue == i) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					}
					return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
				}
			}
		},
		watch: {
		},
		methods: {
			checkItem(value) {
				if(this.disable){
					return
				}
				this.$emit("checkItem", value)
			}
		}
	}
</script>

<style scoped>
	.checkbox {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.checkbox>div {
		align-items: center;
		display: flex;
		justify-content: center;
		font-size: .12rem;
		cursor: pointer;
		padding: .05rem .15rem;
		margin-left: .2rem;
	}
	
	.checkbox img {
		width: .15rem;
		margin-right: .05rem;
		height: .15rem;
	}
</style>